import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatSelect, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';
import { LevelInfoService } from 'src/app/services/http/business/levelInfo/level-info.service';
import { ILevelInfo } from 'src/app/interfaces/levelInfo';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
import { SurveyService } from 'src/app/services/http/business/survey/survey.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-sur-question-cat-edit',
  templateUrl: './sur-question-cat-edit.component.html',
  styleUrls: ['./sur-question-cat-edit.component.css']
})
export class SurQuestionCatEditComponent implements OnInit {

  param: any;
  errorList: IError[] = [];
  personInfo: any;
  errObject: any;
  form: FormGroup;
  errors = new Array();
  eduPackageList: IEducationPackage;
  levelInfoList: ILevelInfo;

  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private eduPackageService: EducationPackageService,
    private levelInfoService: LevelInfoService,
    private errorService: ErrorsService,
    private snackBar: SnackBarService,
    private surService: SurveyService,
    public dialogRef: MatDialogRef<SurQuestionCatEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.createForm();
    this.getEduPackage();
    this.getLevelInfoInit(this.data.PackageId);
  }

  createForm() {
    this.form = this.fb.group({
      Id: [this.data.Id],
      PackageId: [this.data.PackageId, Validators.required],
      LevelInfoId: [this.data.LevelInfoId, Validators.required],
      Title: [this.data.Title, Validators.required],
      Explain: [this.data.Explain, Validators.required]
    });
  }

  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      () => {
        
      }
    );
  }


  getLevelInfo(e: MatSelect) {
    this.levelInfoService.getList(e.value).subscribe(
      res => {
        this.levelInfoList = res.DataList;
      },
     () => {
        
      }
    );
  }

  getLevelInfoInit(packageId:number) {
    this.levelInfoService.getList(packageId).subscribe(
      res => {
        this.levelInfoList = res.DataList;
      },
      () => {
        
      }
    );
  }

  submit(data: any) {
    this.surService.editCat(data).subscribe(
      () => {
        this.dialogRef.close(true);
        this.snackBar.OpenSnackBar(
         'ویرایش با موفقیت انجام شد',
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
